export const ACTION_TYPE = {
  MANUAL: 1,
  CLIENT_FOLLOW_UP: 2,
  LAW_FIRM_FOLLOW_UP: 3,
  PROVIDER_FOLLOW_UP: 4,
  DATA_ENTRY_FOLLOW_UP: 7,
};
